const layerStyles = {
  base: {
    bg: "transparent",
    py: 20,
    px: 20
  },
  card: {
    bg: "brand.1100", //changed from brand.800
    borderRadius: "2xl",
    borderColor: "gray.500",
    px: [4, 6, 8],
    pt: [3, 4, 5],
    pb: [4, 5, 6]
  }
};

export default layerStyles;
